export enum ROUTES_CATEGORIES {
  DEFAULT = ':category',
  AUTO = 'auto',
  UTILITAIRE = 'utilitaire',
  MOTO = 'moto',
  CAMPING_CAR = 'camping-car',
  CARAVAN = 'caravane',
}

export const ROUTES = {
  login: '/connexion',
  logout: '/deconnexion',
  register: '/inscription',
  resetPassword: '/reinitialisation',
  deposit: '/depot',
  category: (category = ROUTES_CATEGORIES.DEFAULT): string =>
    `/depot/cat/${category}(${Object.keys(ROUTES_CATEGORIES)
      // @ts-ignore
      .map(k => ROUTES_CATEGORIES[k] as string)
      .filter(el => el !== ':category')
      .join('|')})`,
  registration: '/immatriculation',
  vehicleType: '/type-vehicule',
  vehiclePrice: '/prix-vehicule',
  vehicleDescription: '/description-vehicule',
  vehicleVersionChoice: '/version-vehicule',
  contactInformation: '/coordonnees',
  photos: '/photos',
  phoneValidation: '/validation-telephone',
  publicationOptions: '/options-publication',
  payment: '/paiement',
  update: (ref = ':reference', action = ':action(modification)'): string => `/annonces/${ref}/${action}`,
  upsell: (ref = ':reference', action = ':action(visibilite)'): string => `/annonces/${ref}/${action}`,
  renew: (ref = ':reference', action = ':action(renouvellement)'): string => `/annonces/${ref}/${action}`,
  phoneValidationUpdate: (ref = ':reference', action = ':action(modification)'): string =>
    `/annonces/${ref}/${action}/validation-telephone`,
  confirmation: '/confirmation',
};
